// Tab strip della pagina Fornitori: una tab per fornitore.
// Pattern visivo identico ai TabButton della vecchia CatalogoPage
// (border-b accent sulla attiva); bottoni veri → tastiera ok di default.

interface SupplierTabsProps {
  tabs: readonly { id: string; label: string }[];
  activeId: string;
  onSelect: (id: string) => void;
}

export function SupplierTabs({ tabs, activeId, onSelect }: SupplierTabsProps) {
  return (
    // Telefono: pillole in una fila che scorre col pollice, come i tab di Fatture.
    <div className="mb-4 flex flex-wrap items-center gap-1.5 max-md:sticky max-md:-top-3 max-md:z-10 max-md:-mx-3 max-md:mb-3 max-md:flex-nowrap max-md:gap-2 max-md:overflow-x-auto max-md:border-b-0 max-md:bg-paper max-md:px-3 max-md:py-2 max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden">
      {tabs.map((tab) => {
        const isActive = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => onSelect(tab.id)}
            className={[
              "inline-flex h-[34px] items-center whitespace-nowrap rounded-full border px-4 text-[12.5px] font-semibold transition-colors duration-100 active:scale-[0.97] max-md:h-9 max-md:shrink-0 max-md:px-3.5 max-md:text-[14px]",
              isActive
                ? "border-ink bg-ink text-on-ink"
                : "border-line-2 bg-card text-ink hover:border-ink-4",
            ].join(" ")}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
